<template>
  <div class="wrapper">
    <ul class="yq_list">
      <li v-for="item in yardList" :key="item.hospCode" @click="push(item.hospCode)">{{ item.hospName }}</li>
    </ul>
    <judgment></judgment>
  </div>
</template>

<script>
import { selectBHosptialinfo, GetHosptal } from "@/request/api.js"
import Judgment from "@/components/Judgment/Judgment.vue";
export default {
  components: {
    Judgment
  },
  data() {
    return {
      yardList: [],
      num: ""
    }
  },
  async created() {
    let loadDataUrl = window.location.href;
    this.num = loadDataUrl.split("?")[1];
    this.getInfo();
  },
  methods: {
    async getInfo(){
      // let res = await selectBHosptialinfo();
      let res = await GetHosptal();
      this.yardList = res.data.obj.resultData;
    },
    push(num){
      if(this.num == 1){
        this.$router.push(`/CollegesDepartments?${num}`);
      } else {
        this.$router.push(`/KeyDepartments?${num}`);
      }
    }
  },
}
</script>

<style lang="less" scoped>
.wrapper{
  width: 100%;
  height: 100%;
  overflow: auto;
  background: #f8f8f8;
  .yq_list{
    display: flex;
    flex-flow: column nowrap;
    >li{
      padding: 16px 0px;
      font-size: 18px;
      border-bottom: 1px solid rgb(206, 206, 206);
      letter-spacing: 1px;
      text-align: center;
      background: rgba(255, 255, 255, 0.8);
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/HospitalInformation/NavigationSelectionYq.vue